import { useHead } from '@unhead/vue';
import { type MaybeRef, unref } from 'vue';

export default (viewName: MaybeRef<string>) => {
  return useHead({
    title: () => `${unref(viewName)} | GPCORE Panel`,
  });
};
